module.exports = __webpack_public_path__ + "img/bg04.391b0a20.gif";